function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import blockies from 'ethereum-blockies';

var BlockiesIdenticon = /*#__PURE__*/function (_Component) {
  _inherits(BlockiesIdenticon, _Component);

  function BlockiesIdenticon(props) {
    _classCallCheck(this, BlockiesIdenticon);

    return _possibleConstructorReturn(this, _getPrototypeOf(BlockiesIdenticon).call(this, props));
  }

  _createClass(BlockiesIdenticon, [{
    key: "getOpts",
    value: function getOpts() {
      return {
        seed: this.props.opts.seed || 'foo',
        color: this.props.opts.color || '#dfe',
        bgcolor: this.props.opts.bgcolor || '#a71',
        size: this.props.opts.size || 15,
        scale: this.props.opts.scale || 3,
        spotcolor: this.props.opts.spotcolor || '#000'
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.draw();
    }
  }, {
    key: "draw",
    value: function draw() {
      blockies.render(this.getOpts(), this.canvas);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement('canvas', {
        ref: function ref(canvas) {
          return _this.canvas = canvas;
        }
      });
    }
  }]);

  return BlockiesIdenticon;
}(Component);

BlockiesIdenticon.defaultProps = {
  opts: {
    seed: 'foo',
    color: '#dfe',
    bgcolor: '#a71',
    size: 15,
    scale: 3,
    spotcolor: '#000'
  }
};
BlockiesIdenticon.propTypes = {
  /**
   * Sets the options for the blockies identicon
   */
  opts: PropTypes.shape({
    seed: PropTypes.string,
    color: PropTypes.string,
    bgcolor: PropTypes.string,
    size: PropTypes.number,
    scale: PropTypes.number,
    spotcolor: PropTypes.string
  })
};
BlockiesIdenticon.displayName = 'BlockiesIdenticon';
export default BlockiesIdenticon;